import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useHistory, useParams } from "react-router-dom";
import AccessHolderForm from "../../Forms/AccessHolder";
import CloseTransactionPanel from "../../OneParkAccount/CloseTransactionPanel";
import { isUndefined } from "lodash";

const CreateEditAccessHolder = ({
  onDelete,
  accessHolderID,
  facilityID,
  onChange,
  unMount,
}) => {
  const history = useHistory();
  const { accessHolderID: routeID } = useParams();

  accessHolderID = !isUndefined(accessHolderID)
    ? accessHolderID
    : routeID !== "add"
    ? routeID
    : undefined;

  useEffect(() => {
    return () => unMount();
  }, []);

  const handleCancel = () => {
    history.goBack();
  };

  const renderCloseTransactionSlot = (accessHolder) => {
    if (!accessHolder?.isOneParkUser || !accessHolder?.accessHolderID) {
      return null;
    }

    // Only show when the access holder is actively parked ("In").
    // "Out" and "Neutral" mean there is no open transaction to close.
    const status = String(accessHolder?.status ?? "").toLowerCase();
    if (status !== "in") {
      return null;
    }

    // CloseTransactionPanel fetches the correct entry time internally via
    // TransactionManagerService.getAccessHolderHistory — the same API used on
    // the OnePark screen. No need to pass lastUse from here.
    return (
      <CloseTransactionPanel
        accessHolderID={accessHolder.accessHolderID}
      />
    );
  };

  const handleFormChange = (accessHolder) => {
    if (typeof onChange === "function") onChange(accessHolder);
  };

  return (
    <div>
      <AccessHolderForm
        accessHolderID={accessHolderID}
        facilityID={facilityID}
        onCancel={handleCancel}
        onChange={handleFormChange}
        onDelete={onDelete}
        beforeStatusSlot={renderCloseTransactionSlot}
      />
    </div>
  );
};

CreateEditAccessHolder.defaultProps = {
  onChange: () => {},
  onDelete: () => {},
  unMount: () => {},
};

CreateEditAccessHolder.propTypes = {
  accessHolderID: PropTypes.string,
  facilityID: PropTypes.string,
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
  unMount: PropTypes.func,
};

export default CreateEditAccessHolder;
